


















import Vue from 'vue';
import { Component, Watch, Prop } from 'vue-property-decorator';

@Component({
  name: 'uc-page'
})
export default class UcPageComponent extends Vue {
  @Prop({ default: '', type: String }) name: string;
  mounted() {
    document.title = this.name;
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/pages/components/uc-page.vue